import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              更新动态
            </h2>
            <p className="text-sm text-foreground-500">最新漫画更新、平台公告与活动资讯</p>
          </div>

          <div className="max-w-[720px] mx-auto">
            <div className="relative pl-6 md:pl-8 border-l-2 border-background-200">
              {updateItems.map((item) => (
                <div key={item.id} className="relative mb-5 last:mb-0">
                  <div className={`absolute -left-[29px] md:-left-[33px] w-3 h-3 rounded-full border-2 border-background-200 bg-background-50 ${
                    item.tag === '活动' ? 'border-accent-400 bg-accent-100' :
                    item.tag === '公告' ? 'border-secondary-400 bg-secondary-100' :
                    'border-primary-400 bg-primary-100'
                  }`}></div>

                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                      item.tag === '活动'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '公告'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-0.5">{item.title}</h3>
                  <p className="text-xs text-foreground-500">{item.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}